export const ENTITY_DRAWER_VIEW_ALL_ROUTE = 'mapRoadAssistance';
export const UNAVAILABLE_STATUSES = ['OFFLINE', 'STANDBY', 'UNAVAILABLE'];
